import { Checkbox, FontColorEnum, Typography } from '@acceso/design-system';
import { Controller, FieldValues, Path, UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { InputTimeV3 } from '@/components/FormFields/InputTimeV3';
import { useDayOfWeekOptions } from '@/components/Schedules/hooks/useDayOfWeekOptions';

type ScheduleItemFormProps<T extends FieldValues> = {
  form: UseFormReturn<T>;
  startHourInputName: Path<T>;
  endHourInputName: Path<T>;
  repetitionDayOfWeek: Path<T>;
};

export function ScheduleItemForm<T extends FieldValues>({
  form,
  startHourInputName,
  endHourInputName,
  repetitionDayOfWeek,
}: ScheduleItemFormProps<T>) {
  const { t } = useTranslation();
  const dayOfWeekOptions = useDayOfWeekOptions();

  return (
    <div>
      <div className="flex w-full gap-3">
        <InputTimeV3
          classname="w-1/2"
          form={form}
          name={startHourInputName}
          label={t('Hora inicio')}
          required
        />

        <InputTimeV3
          classname="w-1/2"
          form={form}
          name={endHourInputName}
          label={t('Hora fin')}
          required
        />
      </div>

      <div className="mt-4 flex flex-col">
        <Typography color={FontColorEnum.Medium20}>{t('Repeticiones')}</Typography>

        <div className="mx-auto flex max-w-[540px] flex-wrap justify-center gap-2 p-2">
          {dayOfWeekOptions.map(dayOfWeek => {
            return (
              <Controller
                key={dayOfWeek.value}
                control={form.control}
                name={repetitionDayOfWeek}
                render={({ field: { value, onChange } }) => {
                  const isSelected = value.includes(dayOfWeek.value);

                  const handleChange: React.FormEventHandler<HTMLInputElement> = event => {
                    const isChecked = event.currentTarget.checked;

                    if (!isChecked) {
                      const newDays = value.filter(day => day !== dayOfWeek.value);
                      onChange(newDays);
                    } else {
                      const newDays = [...value, dayOfWeek.value];
                      onChange(newDays);
                    }
                  };

                  return (
                    <Checkbox
                      labelClassName="px-3 py-2"
                      onChange={handleChange}
                      checked={isSelected}
                    >
                      <Typography color={FontColorEnum.Dark10}>{dayOfWeek.label}</Typography>
                    </Checkbox>
                  );
                }}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
}
